import { useMemo } from 'react';

import { DEFAULT_DARK_THRESHOLD, getLuminance, isDarkColor } from 'lib/helpers/luminance';

/**
 * Resolves the relative luminance of a hex color and whether content on top of it should be light.
 *
 * @param {string} color - Hex color, e.g. '#7C3AED' or '#fff'. Non-hex values yield
 *  `{ luminance: null, isDark: false }` so callers keep their default styling.
 * @param {number} [threshold=DEFAULT_DARK_THRESHOLD] - Luminance cutoff below which the color
 *  counts as dark.
 * @returns {{ luminance: number|null, isDark: boolean }}
 */
const useLuminance = (color, threshold = DEFAULT_DARK_THRESHOLD) =>
  useMemo(
    () => ({ luminance: getLuminance(color), isDark: isDarkColor(color, threshold) }),
    [color, threshold]
  );

export default useLuminance;
